import { ArrowLeft, Button, cn, XClose } from "@dust-tt/sparkle";
import type React from "react";

interface ConversationSidePanelHeaderProps {
  backTooltip?: string;
  children?: React.ReactNode;
  onBack?: () => void;
  onClose?: () => void;
  title?: string;
}

// Matches the "In this chat" drawer header; the parent's `sheet` class adds the shadow.
export function ConversationSidePanelHeader({
  backTooltip = "Back",
  children,
  onBack,
  onClose,
  title,
}: ConversationSidePanelHeaderProps) {
  return (
    <div className="sheet-header relative z-10 flex h-title shrink-0 items-center gap-1 bg-panel-background px-4 @container">
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          icon={ArrowLeft}
          tooltip={backTooltip}
          className="-ml-2 shrink-0"
        />
      )}
      {title && (
        <h2 className="min-w-0 flex-1 truncate text-base font-semibold text-foreground">
          {title}
        </h2>
      )}
      <div
        className={cn(
          "flex items-center",
          title ? "shrink-0" : "min-w-0 flex-1"
        )}
      >
        {children}
      </div>
      {onClose && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          icon={XClose}
          className="text-element-600 hover:text-element-900 shrink-0"
        />
      )}
    </div>
  );
}
